import { ErrorMessages, Rule } from '@ubud/form';
import { Validators } from '@angular/forms';
import { ValidatorFactory } from '@shared/module/validation/validator-factory';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    12/06/2018
 */
export class RegisterUserRule extends Rule {
    public get errorMessages(): ErrorMessages {
        return {
            username: {
                required: (params: any) => 'Username tidak boleh kosong',
            },
            email: {
                required: (params: any) => 'Email tidak boleh kosong',
            },
            password: {
                required: (params: any) => 'Password tidak boleh kosong',
            },
            confirmation_password: {
                required: (params: any) => 'Konfirmasi Password tidak boleh kosong',
                equal: (params: any) => 'Tidak sesuai dengan kata sandi',
            },
            name: {
                required: (params: any) => 'Nama lengkap tidak boleh kosong',
            },
        };
    }

    public get username(): Function {
        return Validators.required;
    }

    public get email(): Function {
        return Validators.required;
    }

    public get password(): Function {
        return Validators.required;
    }

    public get confirmationPassword(): Function {
        return Validators.required;
    }

    public get name(): Function {
        return Validators.required;
    }

    public getFormControls(): { [p: string]: any } {
        return {
            username: ['', this.username],
            email: ['', this.email],
            password: ['', [this.password, ValidatorFactory.equal('confirmation_password', true)]],
            confirmation_password: ['', [this.confirmationPassword, ValidatorFactory.equal('password', false)]],
            name: ['', this.name],
        };
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/rules/register-user.rule.ts